import { AnyType } from "@/types";
import moment, { Moment } from "moment";
import isElectron from 'is-electron';

export const omit: (a: AnyType, b: string | Array<string>) => AnyType = (
  a,
  b
) => {
  b = Array.isArray(b) ? b : [b];
  const ret: AnyType = {};
  Object.keys(a).forEach((ak) => {
    if (!b.includes(ak)) {
      ret[ak] = a[ak];
    }
  });
  return ret;
};

export const pick: (a: AnyType, b: string | Array<string>) => AnyType = (
  a,
  b
) => {
  b = Array.isArray(b) ? b : [b];
  const ret: AnyType = {};
  Object.keys(a).forEach((ak) => {
    if (b.includes(ak)) {
      ret[ak] = a[ak];
    }
  });
  return ret;
};

export const storage = {
  save: (k: string, v: any) => {
    if (typeof v === "string") {
      window.localStorage.setItem(k, v);
      return;
    }
    try {
      v = JSON.stringify(v);
    } catch (ex) {
      //
    }
    window.localStorage.setItem(k, v);
  },
  get: (k: string) => {
    let av = window.localStorage.getItem(k) || "{}";
    try {
      av = JSON.parse(av);
    } catch (ex) {
      //
    }
    return av as any;
  },
  remove: (k: string) => {
    window.localStorage.removeItem(k);
  },
};

export const TIME_FORMAT = "YYYY-MM-DD HH:mm:ss";
const __format = (date: Moment) => date.format(TIME_FORMAT);

export const time = {
  format: (date: Moment) => date.format("YYYY-MM-DD HH:mm:ss"),
  formatNow: () => __format(moment()),
};
export const isMobile = () => {
  return !!navigator.userAgent.match(/AppleWebKit.*Mobile.*/);
};
export const isIpad = () => {
  return navigator.userAgent.indexOf('iPad') > -1;
};
export const isWeixin = () => {
  const ua = navigator.userAgent.toLowerCase(); // 获取判断用的对象
  return ua.indexOf("micromessenger") != -1;
};
export const isChrome = () => {
  return navigator.userAgent.indexOf("Chrome") !== -1;
};

export const inElectron=()=>{
  return isElectron();
}

export const notChromeMessage = () => {
  if (isChrome) return "";
  return "当前浏览器不支持会议所有功能，请下载谷歌浏览器";
};
